/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "เพิ่ม"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "ลบออกทั้งหมด"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var thTH = Object.assign(TranslationProviderComponent, {
  translations
});

export { thTH as t };
//# sourceMappingURL=th-TH-CcG7aYO6.js.map
